import Link from 'next/link';
import { Group, Box, Text, Image } from '@mantine/core';
import styles from './AdminShortcuts.module.scss'; // remplace par ton vrai fichier
import { primaryColor } from '@/src/styles/colors';

type IconItem = {
    href: string;
    icon: string;
    label: string;
};

type AdminShortcutsProps = {
    iconItems: IconItem[];
};

export default function AdminShortcuts({ iconItems }: AdminShortcutsProps) {
    return (
        <Group justify="center" gap="xl" className={styles.cardRow} w="100%">
            {iconItems.map((item) => (
                <Box
                    key={item.label}
                    component={Link}
                    href={item.href}
                    className={styles.iconCard}
                >
                    <Image
                        src={item.icon}
                        alt={item.label}
                        style={{ margin: '0 auto' }}
                    />
                    <Text ta="center" size="sm" mb="sm" fw={500} c={primaryColor} className={styles.label}>
                        {item.label}
                    </Text>
                </Box>
            ))}
        </Group>
    );
}
